export default __webpack_public_path__ + "static/media/linkedin.beaf2c90.png";